import { jsxs as _jsxs } from "react/jsx-runtime";
import { useUserContext } from '../../UserContext';
export const UserGreeting = ({ className }) => {
    var _a, _b, _c;
    const uctx = useUserContext();
    return ((_b = (_a = uctx.data) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.name) ? _jsxs("span", { children: ["Hei, ", (_c = uctx.data.user) === null || _c === void 0 ? void 0 : _c.name.first, "!"] }) : null;
};
